module.exports = __webpack_public_path__ + "../resources/img/ic_scan_p2.6ddfbfe5.svg";